/**
 * Catalogue v1, second half of the route: Силовая · Колёса · Салон · На
 * прогретом · Диагностика и файлы (steps 16–31).
 */
import { ALL_OUTCOMES, FILES_CAPTURE, FILES_OUTCOMES, NOT_EV, photos, VIDEO_SECONDS, video, ZONES_ENGINE_BAY, ZONES_OPENINGS, ZONES_TRUNK, ZONES_UNDERBODY, ZONES_WHEELS_FRONT, ZONES_WHEELS_REAR, } from './catalogue.v1.parts.js';
const BASE = { required: true, outcomes: ALL_OUTCOMES, mediaVisibility: 'public' };
const TIRE_CHIPS = [
    'tread_low',
    'tire_old',
    'uneven_wear',
    'tire_damage',
    'rim_damage',
    'other',
];
export const V1_INSIDE = [
    // ------------------------------------------------------------ Силовая
    {
        ...BASE,
        key: 'engine_bay',
        section: 'powertrain',
        capture: photos(2, 'engine'),
        chips: ['body_repair_marks', 'oil_leak', 'coolant_leak', 'wiring_damage', 'other'],
        defect: { side: 'engine_bay', zones: ZONES_ENGINE_BAY },
    },
    {
        ...BASE,
        key: 'trunk',
        section: 'powertrain',
        capture: photos(2, 'exterior'),
        chips: ['body_repair_marks', 'rust', 'trunk_moisture', 'spare_missing', 'other'],
        defect: { side: 'trunk', zones: ZONES_TRUNK },
    },
    {
        ...BASE,
        key: 'door_openings',
        section: 'powertrain',
        capture: photos(2, 'exterior'),
        chips: ['body_repair_marks', 'paint_overspray', 'rust', 'panel_gap', 'other'],
        defect: { side: 'openings', zones: ZONES_OPENINGS },
    },
    // ------------------------------------------------------------- Колёса
    {
        ...BASE,
        key: 'wheels_front',
        section: 'wheels',
        capture: photos(2, 'wheels'),
        chips: TIRE_CHIPS,
        value: { kind: 'tread', required: true, wheels: ['front_left', 'front_right'] },
        defect: { side: 'wheels', zones: ZONES_WHEELS_FRONT },
    },
    {
        ...BASE,
        key: 'wheels_rear',
        section: 'wheels',
        capture: photos(2, 'wheels'),
        chips: TIRE_CHIPS,
        value: { kind: 'tread', required: true, wheels: ['rear_left', 'rear_right'] },
        defect: { side: 'wheels', zones: ZONES_WHEELS_REAR },
    },
    {
        ...BASE,
        key: 'brakes',
        section: 'wheels',
        capture: photos(1, 'wheels'),
        chips: ['brake_discs_worn', 'brake_pads_worn', 'other'],
        defect: { side: 'wheels', zones: [...ZONES_WHEELS_FRONT, ...ZONES_WHEELS_REAR] },
    },
    // -------------------------------------------------------------- Салон
    {
        ...BASE,
        key: 'interior_wear',
        section: 'interior',
        capture: photos(2, 'interior'),
        chips: ['wear_vs_mileage', 'upholstery_damage', 'smell', 'other'],
    },
    {
        ...BASE,
        key: 'moisture',
        section: 'interior',
        capture: photos(1, 'interior'),
        chips: ['moisture', 'flood_traces', 'mold', 'other'],
    },
    {
        ...BASE,
        key: 'airbags',
        section: 'interior',
        capture: photos(1, 'interior'),
        chips: ['airbag_light', 'airbag_tampered', 'other'],
    },
    {
        ...BASE,
        key: 'electrics',
        section: 'interior',
        capture: photos(1, 'interior'),
        chips: ['electrics_fault', 'multimedia_fault', 'other'],
    },
    {
        ...BASE,
        key: 'climate',
        section: 'interior',
        capture: photos(1, 'interior'),
        chips: ['ac_fault', 'heater_fault', 'other'],
    },
    // ------------------------------------------------------- На прогретом
    {
        ...BASE,
        key: 'leaks_warm',
        section: 'warm',
        capture: photos(1, 'undercarriage'),
        chips: ['oil_leak', 'coolant_leak', 'gearbox_leak', 'other'],
        defect: { side: 'underbody', zones: ZONES_UNDERBODY },
    },
    {
        ...BASE,
        key: 'dipstick_cap',
        section: 'warm',
        capture: photos(2, 'engine'),
        chips: ['oil_emulsion', 'oil_low', 'oil_dirty', 'other'],
        appliesTo: NOT_EV,
    },
    {
        ...BASE,
        key: 'engine_running',
        section: 'warm',
        capture: video(VIDEO_SECONDS.engineRunning, 'engine'),
        chips: ['engine_noise', 'rough_idle', 'gearbox_shift', 'smoke', 'warning_lights', 'other'],
        appliesTo: NOT_EV,
    },
    {
        ...BASE,
        key: 'battery',
        section: 'warm',
        capture: photos(1, 'engine'),
        chips: ['battery_corrosion', 'battery_old', 'battery_weak', 'other'],
    },
    // ------------------------------------------------ Диагностика и файлы
    {
        // A5: optional, never blocks finalize; files here are shown to the buyer
        // («приложил подборщик»), unlike the техпаспорт photos of step 5.
        key: 'diagnostics_files',
        section: 'diagnostics',
        required: false,
        capture: FILES_CAPTURE,
        chips: ['diag_errors', 'other'],
        outcomes: FILES_OUTCOMES,
        mediaVisibility: 'public',
    },
];
//# sourceMappingURL=catalogue.v1.inside.js.map